import { useResetTenantOnboardingSkipMutation } from 'api/Common/mutation';
import { useGetBillsUserPersist } from 'pages/Bills/List/api/queries';
import { usePersistBillsFilterMutation } from 'pages/Bills/List/api/mutation';
import { IBillsUserPersistPostBody } from 'pages/Bills/List/types';
import { Logger } from 'utils/logger';
import { clearAuthSessionStorage } from 'utils/sessionIdle';

export const useLogout = () => {
  const { mutateAsync: resetTenantOnboardingSkipAsync } =
    useResetTenantOnboardingSkipMutation();
  const { mutateAsync: clearBillsUserPersistAsync } =
    usePersistBillsFilterMutation();
  const { data: billsUserPersist } = useGetBillsUserPersist();

  const logout = async () => {
    // Preserve sort preference across logout — only filter/tab/page fields are cleared.
    const currentBills = billsUserPersist?.web?.bills;
    const clearBillsPersistPayload: IBillsUserPersistPostBody = {
      data: {
        web: {
          bills: {
            sort_by: currentBills?.sort_by,
            sort_order: currentBills?.sort_order ?? 'desc',
          },
        },
        mobile: {},
      },
    } as IBillsUserPersistPostBody;

    // Run both cleanup calls in parallel so logout latency is bounded by the
    // slower of the two, not their sum. Both are best-effort — failures are
    // logged but never block the redirect.
    const [billsResult, onboardingResult] = await Promise.allSettled([
      clearBillsUserPersistAsync(clearBillsPersistPayload),
      resetTenantOnboardingSkipAsync(),
    ]);

    if (billsResult.status === 'rejected') {
      Logger.error({
        message: 'Error clearing bills user-persist on logout',
        data: billsResult.reason,
      });
    }
    if (onboardingResult.status === 'rejected') {
      Logger.error({
        message: 'Error resetting tenant onboarding skip flag',
        data: onboardingResult.reason,
      });
    }

    clearAuthSessionStorage();
    sessionStorage.clear();
    window.location.assign('/login');
  };

  return { logout };
};
